import { GamNetworkConfig } from '@pubstack/common/src/gam/adx'
import { MutationToasts, useMutation, useQuery } from '~/api/api-client'

export const GAM_NETWORKS_QUERY_KEYS = ['admin', 'scopes', 'gam-networks']
const url = '/admin/scopes/gam-network'
//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useGamNetworks = () => {
  return useQuery<GamNetworkConfig[]>({
    url,
    keys: GAM_NETWORKS_QUERY_KEYS,
  })
}

export const useGamNetwork = (scopeId: string) => {
  return useQuery<GamNetworkConfig[]>({
    url: `/admin/scopes/${scopeId}/integration/gam/gam-network`,
    keys: [...GAM_NETWORKS_QUERY_KEYS, scopeId],
  })
}
//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------
export const useCreateGamNetworks = (toasts: MutationToasts = {}) => {
  return useMutation<any>({
    method: 'post',
    url,
    collectionKeys: GAM_NETWORKS_QUERY_KEYS,
    ...toasts,
  })
}

export const useCreateGamNetwork = (scopeId: string, toasts: MutationToasts = {}) => {
  return useMutation<{ networkCode: string; scopeName: string }, GamNetworkConfig>({
    method: 'post',
    url: `/admin/scopes/${scopeId}/integration/gam/gam-network`,
    collectionKeys: [...GAM_NETWORKS_QUERY_KEYS, scopeId],
    ...toasts,
  })
}

export const useUpdateGamNetwork = (scopeId: string, networkCode: string, toasts: MutationToasts = {}) => {
  return useMutation<GamNetworkConfig, GamNetworkConfig>({
    method: 'put',
    url: `/admin/scopes/${scopeId}/integration/gam/gam-network/${networkCode}`,
    collectionKeys: [...GAM_NETWORKS_QUERY_KEYS, scopeId],
    ...toasts,
  })
}
